export default __webpack_public_path__ + "static/media/Error.97683aaa.svg";